import { useIsUrlActive } from "@octopusdeploy/design-system-components";
import { ControlledTabsContainer, TabItem } from "@octopusdeploy/design-system-octopus-components";
import type { ProjectResource } from "@octopusdeploy/octopus-server-client";
import type { Url } from "@octopusdeploy/portal-routes";
import { links } from "@octopusdeploy/portal-routes";
import { isUrl } from "~/components/Navigation/InternalLink/isUrl";
import { useSpaceAwareNavigation } from "~/components/Navigation/SpaceAwareNavigation/useSpaceAwareNavigation";
import { useUrlResolver } from "~/components/Navigation/useUrlResolver";
interface TemplateTab {
    text: string;
    link: Url;
    warning: string | undefined;
}
function warning(yes: boolean): string | undefined {
    return yes ? "Some of the required variable values have not been set" : undefined;
}
export interface TemplatesWarnings {
    projectTemplates: boolean;
    commonTemplates: boolean;
}
interface ProjectTenantVariablesTabsProps {
    project: ProjectResource;
    warnings: TemplatesWarnings;
}
export default function ProjectTenantVariablesTabs({ project, warnings }: ProjectTenantVariablesTabsProps) {
    const isUrlActive = useIsUrlActive();
    const urlResolver = useUrlResolver();
    const navigation = useSpaceAwareNavigation();
    const tabs: TemplateTab[] = [
        { text: "Project Templates", link: links.tenantVariablesProjectTemplatesPage.generateUrl({ spaceId: project.SpaceId, projectSlug: project.Slug }), warning: warning(warnings.projectTemplates) },
        { text: "Common Templates", link: links.tenantVariablesCommonTemplatesPage.generateUrl({ spaceId: project.SpaceId, projectSlug: project.Slug }), warning: warning(warnings.commonTemplates) },
    ];
    const activeTabOrDefault = tabs.find((t) => isUrlActive(t.link, "if path partially matches")) || tabs[0];
    const activeLink = isUrl(activeTabOrDefault.link) ? urlResolver.resolve(activeTabOrDefault.link) : activeTabOrDefault.link;
    return (<ControlledTabsContainer value={activeLink} onChange={(link) => navigation.navigate(link)}>
            {tabs.map((t) => {
            const resolvedLink = isUrl(t.link) ? urlResolver.resolve(t.link) : t.link;
            return <TabItem key={resolvedLink} label={t.text} value={resolvedLink} warning={t.warning}></TabItem>;
        })}
        </ControlledTabsContainer>);
}
